import React, { useEffect } from 'react';
import { Toaster } from 'sonner';
import Lenis from 'lenis';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import ZBrushSection from './components/ZBrushSection';
import RTSSection from './components/RTSSection';
import RPGSection from './components/RPGSection';
import About from './components/About';
import Resume from './components/Resume';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App font-body">
      <Navigation />
      <main>
        <Hero />
        <ZBrushSection />
        <RTSSection />
        <RPGSection />
        <About />
        <Resume />
        <Contact />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}
